import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class LocalStorageService {
  private storageSub = new BehaviorSubject<any>(null);

  constructor() {}
  _setBehaviorSubject() {
    window.addEventListener("storage", (event: StorageEvent) => {
      if (event.storageArea === localStorage) {
        this.storageSub.next({ key: event.key, value: event.newValue });
      }
    });
  }

  storageChanges() {
    this._setBehaviorSubject();
    return this.storageSub.asObservable();
  }

  setItem(key: string, value: string): void {
    this._setBehaviorSubject();
    localStorage.setItem(key, value);
    this.storageSub.next({ key, value: value });
  }

  getItem(key: string): string | null {
    return localStorage.getItem(key);
  }

  public removeItem(key: string): void {
    this._setBehaviorSubject();
    localStorage.removeItem(key);
    this.storageSub.next({ key, value: null });
  }
}
